<template>
    <div>
        <v-dialog 
            v-model="titleDialog" 
            transition="dialog-bottom-transition"
            width="50%">
            <v-card>
                <v-card-title class="primary darken-2 white--text">Give this project a title.</v-card-title>
                <v-card-text>
                    <v-text-field
                        v-model="userProjectTitle"
                        class="my-4 pa-2"
                        label="Title"
                        single-line
                        :rules="userProjectTitle != null ? max100chars : []"
                        counter>
                    </v-text-field>
                    <div class="d-flex d-block justify-end">
                        <v-btn
                            class=""
                            color="primary darken-1"
                            :disabled="userProjectTitle == undefined || userProjectTitle.length > 100"
                            @click="updateProjectTitle()">
                            Save
                        </v-btn>
                    </div>
                </v-card-text>
            </v-card>
        </v-dialog>

        <v-card elevation="2"
                class="avenir pb-6 px-4 flex-grow-1" 
                style="border-top: 6px solid #00818E">
            
            <div v-if="!readyToLoadTeam" class="text-center py-12" style="width: 100%">
                <v-progress-circular indeterminate color="primary" class="my-12" size="40" width="3"></v-progress-circular>
            </div>

            <div v-if="readyToLoadTeam" class="d-flex pt-2 pb-4 text-center flex-column">
                <div class="d-block mt-6 mb-3" v-if="projectDetails.module_key != 'buyer'">
                    <div class="d-block status_project_title general_grey--text">
                        {{ userProjectTitle }}
                        <v-icon
                            small
                            color="primary"
                            class="mt-n1"
                            @click="titleDialog = true">
                            mdi-pencil
                        </v-icon>
                    </div>
                </div>
                <div v-if="projectDetails.secondary_access" class="d-inline mb-3">
                    <v-icon color="general_grey lighten-2">mdi-account-multiple-plus</v-icon>
                </div>

                <div v-if="projectDetails.module_key != 'entity-maintenance-program'">
                    <div class="d-block my-4" v-if="projectDetails.module_key != 'buyer'">
                        <div class="d-block status_title general_grey--text">Status</div>
                        <v-progress-circular 
                            :value="projectDetails.complete == 0 ? 0.5 : projectDetails.complete"
                            :class="projectDetails.status_color"
                            :rotate="-90"
                            class="my-2"
                            size="175" 
                            width="20">
                            <div>
                                <div class="d-block sansation_subtitle font-weight-medium">{{ projectDetails.complete }}%</div>
                                <div class="d-block status_title font-weight-medium">{{ projectDetails.status_text }}</div>
                            </div>
                        </v-progress-circular>
                    </div>

                    <div class="d-block my-4" v-else>
                        <div class="d-block status_title general_grey--text">Buyer Profile Status</div>
                        <v-progress-circular 
                            :value="projectDetails.questionnaire_percentage == 0 ? 0.5 : projectDetails.questionnaire_percentage"
                            :color="projectDetails.questionnaire_percentage == 100 ? `primary` : `secondary`"
                            :rotate="-90"
                            class="mt-6 mb-3"
                            size="175" 
                            width="20">
                            <div>
                                <div class="d-block sansation_subtitle font-weight-medium">{{ projectDetails.questionnaire_percentage }}%</div>
                            </div>
                        </v-progress-circular>
                    </div>
                </div>

                <div class="d-block my-6" v-if="['buyer', 'entity-maintenance-program'].includes(projectDetails.module_key) == false">
                    
                    <div class="d-block status_title general_grey--text">{{ has_calls ? 'Project Calls' : 'Current Step' }}</div>
                    <div class="d-block avenir_book status_subtitle primary--text text--darken-1">{{ has_calls ? projectDetails.calls_used+' of '+projectDetails.calls_allowed+' calls used' : projectDetails.stage_name_text }}</div>
                    
                </div>
                <div v-else>
                    <div v-if="projectDetails.module_key !== 'entity-maintenance-program'" class="d-block my-6">
                        <div class="d-block status_title general_grey--text">Progress</div>
                        <div class="d-block avenir_book status_subtitle primary--text text--darken-1" v-if="projectDetails.questionnaire_progress">{{ projectDetails.questionnaire_progress.finished }} of {{ projectDetails.questionnaire_progress.total }} sections</div>
                        <div class="d-block avenir_book status_subtitle primary--text text--darken-1" v-else>Not Started</div>
                    </div>
                </div>
                
                <div v-if="projectDetails.module_key != 'entity-maintenance-program'">
                  <div class="d-block my-6" v-if="projectDetails.module_key != 'buyer'">
                      <div class="d-block status_title general_grey--text">{{ has_revisions ? 'Revision Rounds' : 'Start Date' }}</div>
                      <div class="d-block avenir_book status_subtitle primary--text text--darken-1">{{ has_revisions ? projectDetails.revisions_used+' of '+projectDetails.revision_rounds+' revisions used' : formatDate(projectDetails.date_initialized, 'mediumDate') }}</div>
                  </div>
                  <div class="d-block my-6" v-else>
                      <div class="d-block status_title general_grey--text">Eligible to Express Interest</div>
                      <div class="d-block avenir_book status_subtitle primary--text text--darken-1">{{ projectDetails.status == 'completed' ? 'Yes' : 'No' }}</div>
                  </div>
                </div>

                <div class="d-block my-6" v-if="entityFilingModules.includes(projectDetails.module_key) && projectDetails.filing_status">
                    <div class="d-block status_title general_grey--text">Entity Filing Status</div>
                    <div class="d-block avenir_book status_subtitle primary--text text--darken-1">{{ projectDetails.filing_status }}</div> 
                </div>

                <div class="d-block my-6" v-if="projectDetails.module_key != 'buyer' && projectDetails.module_key != 'entity-maintenance-program'">
                    <div class="d-block status_title general_grey--text">{{ projectDetails.status == 'complete' ? 'Completion Date' : 'Estimated Completion Date' }}</div>
                    <div class="d-block avenir_book status_subtitle primary--text text--darken-1">{{ formatDate(projectDetails.close_date, 'mmm. d, yyyy') }}</div>
                    <div class="d-block avenir_book status_subtitle error--text text--darken-3" v-if="projectDetails.expedite">Expedited</div>
                </div>
                <div class="d-block my-6" v-if="projectDetails.module_key == 'entity-maintenance-program'">
                    <div class="d-block status_title general_grey--text">Resolutions Completed</div>
                    <div class="d-block avenir_book status_subtitle primary--text text--darken-1">{{ projectDetails.resolutions_data ? Object.keys(projectDetails.resolutions_data).length : 0 }}/10</div>
                </div>
                <div class="d-block my-6" v-if="projectDetails.module_key == 'entity-maintenance-program'">
                    <div class="d-block status_title general_grey--text">Annual Report</div>
                    <div class="d-block avenir_book status_subtitle primary--text text--darken-1">{{ projectDetails.annual_report_date ? projectDetails.annual_report_date.substr(0, 10) : "No Report Date Added" }}</div>
                    <div class="d-block  general_grey--text">Status: {{ projectDetails.annual_report_status ? optionLookup(progress_options, projectDetails.annual_report_status) : "Status Not Set" }}</div>
                </div>
                <div class="d-block my-6" v-if="projectDetails.module_key == 'entity-maintenance-program'">
                    <div class="d-block status_title general_grey--text">Annual Filing</div>

                    <div class="d-block avenir_book status_subtitle primary--text text--darken-1">{{ projectDetails.annual_filing_date ? projectDetails.annual_filing_date.substr(0, 10) : "No Filing Date Added" }}</div>
                    <div class="d-block  general_grey--text">Status: {{ projectDetails.filing_completion_status ? optionLookup(progress_options, projectDetails.filing_completion_status) : "Status Not Set" }}</div>
                    <div class="d-block general_grey--text">Type: {{ projectDetails.annual_report_type ? optionLookup(report_type_options, projectDetails.annual_report_type) : "No Type Set" }}</div>
                    
                </div>
                <div class="d-block mx-8 my-6" v-if="projectDetails.module_key == 'entity-maintenance-program' ">
                    <div class="d-block status_title general_grey--text">Recommended Annual Meeting Date</div>
                    <div class="d-block avenir_book status_subtitle primary--text text--darken-1">{{ projectDetails.recommended_annual_meeting_date ? projectDetails.recommended_annual_meeting_date.substr(0, 10) : "No Meeting Date Added" }}</div>
                </div>


            </div>
        </v-card>
    </div>
</template>

<script>
    import axios from "axios";
import Cookie from "js-cookie";
    import appUrls from '../helpers/environment';
   	import dateFormat, { masks } from "dateformat";

    export default {
        name: 'ProjectStatus',

        props: {
            projectDetails: {},
            authUser: {},
            readyToLoadTeam: Boolean,
        },

        data () {
            return {
                titleDialog: false,
                defaultTitle: 'Give this Project a Title',
                max100chars: [v => v.length <= 100 || 'Max 100 characters'],
                entityFilingModules: [
                    'entity-support-premium', 
                    'entity-support-elite',
                    'merger-premium', 
                    'merger-elite'
                ]
            }
        },

        computed: {
            userProjectTitle: {
                get() {
                    return this.projectDetails.project_title ? this.projectDetails.project_title : this.defaultTitle
                },
                set(val) {
                    this.projectDetails.project_title = val
                }
            },
            
            has_calls: function () {
                return this.hasCalls()
            },
            
            has_revisions: function () {
                return this.hasRevisions()
            },
            status_options () {
                return [
                    { value: 'open',        label: 'Open' },
                    { value: 'review',      label: 'Review' },
                    { value: 'waiting',     label: 'Awaiting Data' },
                    { value: 'processing',  label: 'Processing' },
                    { value: 'complete',    label: 'Complete' },
                    { value: 'hold',        label: 'Hold' },
                    { value: 'closed',      label: 'Closed' },
                    { value: 'upgrade',     label: 'Upgrade/Downgrade' },
                ];
            },
            progress_options () {
                return [
                    { value: 'not_started',     label: 'Not Started' },
                    { value: 'pending',         label: 'Pending' },
                    { value: 'completed',       label: 'Completed' },
                    { value: 'not_applicable',  label: 'Not Applicable' },
                    { value: 'not_included',    label: 'Not Included – Client Responsibility' },
                    
                    
                ];
            },
            report_type_options () {
                return [
                    { value: 'annual',        label: 'Annual' },
                    { value: 'biannual_even',      label: 'Biannual (even)' },
                    { value: 'biannual_odd',  label: 'Biannual (odd)' },
                    { value: 'none',    label: 'None' },
                    { value: 'tax_report',  label: 'Tax Report' },
                    
                ];
            },
        },

        mounted () {
            // console.log(this.projectDetails)
            // if ( this.readyToLoadTeam ) {
            //     this.hasCalls()
            //     this.hasRevisions()
            // }
        },

        methods: {
			hasCalls: function () {
                return this.projectDetails.calls_allowed
            },

            hasRevisions: function () {
                return this.projectDetails.revision_rounds
            },

            formatDate: function ( date, mask ) {
                if ( date == null ) {
                    if ( this.projectDetails.module_class == 1 ) {
                        const day_type = this.projectDetails.module_key == 'valuation-starter' ? 'calendar' : 'business'
                        return `7 ${day_type} days after Questionnaire`
                    } else {
                        return `Calculated after Questionnaire`
                    }
                }
                return dateFormat(date.substr(0,10)+' 00:00:00', mask)
            },

            updateProjectTitle: async function () {
                try {
                    const add_project_title_rs = await axios.put(`${appUrls.api}/api/project_title`, {
                        headers: { authentication: Cookie.get('token'), "Content-Type": "application/json" },
                        project: this.projectDetails
                    })

                    if ( add_project_title_rs.data ) {
                        this.titleDialog = false
                    }
                } catch ( error ) {
                    console.log(error);
                }
            },
            optionLookup(options, value) {
                if (!value) return null;
                const option = options.filter((o) => {
                    return o.value == value
                })

                // console.log('opt lookukp', option[0], value);
                return option[0].label;
            },
        }
    }
</script>

<style scoped>
    .status_project_title {
        font-family: 'Sansation';
        font-size: 1.225rem !important;
    }
    .status_title {
        font-family: 'Sansation';
        font-size: 1.12rem !important;
    }
	.status_subtitle {
		font-size: 1rem !important;
	}
</style>


// WEBPACK FOOTER //
// src/components/ProjectStatus.vue